<template>
	<div>
		<b-dropdown menu-class="w-100" :text="text" style="width: 100%" :disabled="!active">
			<div class="dropdown-scroll">
				<span v-for="entity in entityList" :key="entity.name">
					<b-form-checkbox
						:id="entity.name"
						:disabled="entity.disabled"
						v-model="entity.label"
						:name="entity.name"
						@change="changed"
					>
						{{ entity.name }}
					</b-form-checkbox>
				</span>
			</div>
		</b-dropdown>

		<b-form-invalid-feedback :id="`${name}-feedback`">
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String
		},
		entityList: {
			type: Array
		},
		text: {
			type: String
		},
		id: {
			type: String
		},
		value: {
			type: [String, Boolean]
		},
		name: {
			type: String
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		}
	},
	data() {
		return {
			active: true
		};
	},
	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	},
	methods: {
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},
		changed() {
			let check = false;
			let id = 0;
			this.entityList.forEach((e) => {
				if ((e.id == -1 || e.id == -2) && e.label == true) {
					id = e.id;
					check = true;
				}
			});
			this.$emit("checkChange", id);
			return check;
		}
	}
};
</script>
<style>
.dropdown-scroll {
	max-height: 200px;
	overflow-y: auto;
}
</style>
